import { Channel } from '@src/api/shared/community/channelApiClient';
import { ChannelContext } from '@src/hooks/useChannel';
import React, { ReactNode } from 'react';

type ChannelProviderProps = {
  channel: Channel | null;
  children: ReactNode;
};

/**
 * チャンネルコンテキストプロバイダー
 *
 * チャンネルデータをコンポーネントツリー全体で共有するためのプロバイダーコンポーネント
 * propsでチャンネルデータを複数階層にわたって受け渡す必要性を排除します
 *
 * @param channel - 共有するチャンネルデータ
 * @param children - 子コンポーネント
 *
 * @example
 * ```tsx
 * <ChannelProvider channel={channel}>
 *   <ChatBox />
 *   <CommunitySidebar />
 * </ChannelProvider>
 * ```
 */
export const ChannelProvider: React.FC<ChannelProviderProps> = ({ channel, children }) => {
  return <ChannelContext.Provider value={{ channel }}>{children}</ChannelContext.Provider>;
};
